/*
 * @Author: liyxt
 * @Date: 2019-06-27 18:48:49
 * @LastEditors: liyxt
 * @LastEditTime: 2019-08-19 16:32:37
 * @Description: file content
 */
// import ReactDOM from 'react-dom';

function clearToast() {
	let toastArr = document.getElementsByClassName('toast-zijinyun-project');
	let toastArr1 = window.top.document.getElementsByClassName('toast-zijinyun-project');
	clearAllToast(toastArr);
	clearAllToast(toastArr1);
	if (window.toastModal) {
		window.toastModal = [];
	}
	if (window.toastModalLt) {
		window.toastModalLt = [];
	}
}

function clearAllToast(Arr) {
	if (Arr) {
		Array.from(Arr).forEach(el => {
			if (el) {
				// ReactDOM.unmountComponentAtNode(el);
				el.parentNode.removeChild(el);
			}
		});
	}
}

export default clearToast;
